import { selfAxios, initSelfAxios } from "@oppein/op-utils";
import { getOauth2AccessToken, AppCode, SubAppCode } from "./factory";

const getEnvMode = () => {
  switch(process.env.ENV_NAME.toLowerCase()){
    case 'sit':
      return 'uat'
    case 'uat':
      return 'uat'
    case 'ver':
      return 'ver'
    case 'pro':
      return 'pro'
    default:
      return 'pro'
  }
};

initSelfAxios({
  envMode: getEnvMode(),
  axiosDefaults: {
    headers: {
      common: {
        "Oauth2-AccessToken": getOauth2AccessToken(),
        AppCode: AppCode,
        SubAppCode: SubAppCode,
      },
    },
  },
});

// TODO 还没有处理拦截器相关逻辑，相关逻辑应该和这个项目一致。特别是错误提示相关
// selfAxios.interceptors.response.use(...responseHandleNewsso);
// selfAxios.interceptors.response.use(...axiosErrorInterceptors);



// WEBPACK FOOTER //
// ./src/api/init-op-utils-self-axios.js